import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import styles from "../../assets/css/LoginEoffice.module.css";
import axios from "axios";
import { de } from "date-fns/locale";

const CheckUserLogin = () => {

  document.title = "Login | FlexibleTime";

  const baseURL = process.env.REACT_APP_API_CORS;
  const appURL = process.env.REACT_APP_URL;

  const [searchParams] = useSearchParams();
  const [query] = React.useState(
    searchParams.get("reference")
  );

  const setCookie = async (nameToken, data, duration = 1) => {
    let expires;
    if (duration) {
      var date = new Date();
      date.setTime(date.getTime() + duration * 24 * 60 * 60 * 1000);
      expires = `expires=${date.toUTCString()}`;
    }
    document.cookie = nameToken + "=" + data + ";" + expires + "; path=/";
  };

  useEffect(() => {
    const fetchData = async () => {
      let path = query ? 'LoginByCode' : '/e-office/requireLogin';
      if (path !== 'LoginByCode') {

        let { data } = await axios.get(`${baseURL}${path}`);
        if (data.status) {
          window.location.replace(data.url);
        } else {
          window.location.replace(`${appURL}/login`);
        }

      } else {

        let path = '/login/reference';
        let { data } = await axios.post(`${baseURL}${path}`, {
          reference: query
        }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });

        if (data.status) {
          const userData = data.user;
          const position = data.user.position;
          delete data.user.position;

          await setCookie('userData', encodeURIComponent(JSON.stringify(userData)));
          await setCookie('userToken', data.token);
          await setCookie('userPosition', encodeURIComponent(JSON.stringify(position)));
          await setCookie('userEofficeAccessToken', data.e_office_access_token);
          await setCookie('userEofficeIdToken', data.e_office_id_token);

          setTimeout(() => {
            window.location.replace(`${appURL}/`);
          }, 800);

        } else {
          window.location.replace(`${appURL}/login`);
        }

      }
    }
    fetchData();

  }, [query, baseURL, appURL]);

  return (
    <React.Fragment>
      <div className={styles.overlay}>
        <div className={styles.overlay__inner}>
          <div className={styles.overlay__content}><span className={styles.spinner}></span></div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CheckUserLogin;
